import { black, green, white, darkBg } from "@/constants/colors";

export const darkAutoFillStyles = {
  "& input:-webkit-autofill": {
    "-webkit-text-fill-color": "#FFF",
    "-webkit-box-shadow": "0 0 0px 1000px #2c2c2c inset",
    transition: "background-color 5000s ease-in-out 0s",
  },
  "& input:-webkit-autofill:hover": {
    "-webkit-text-fill-color": "#FFF",
    "-webkit-box-shadow": "0 0 0px 1000px #2c2c2c inset",
    transition: "background-color 5000s ease-in-out 0s",
  },
  "& input:-webkit-autofill:focus": {
    "-webkit-text-fill-color": "#FFF",
    "-webkit-box-shadow": "0 0 0px 1000px #2c2c2c inset",
    transition: "background-color 5000s ease-in-out 0s",
  },
};

export const lightAutoFillStyles = {
  "& input:-webkit-autofill": {
    "-webkit-text-fill-color": "#000",
    "-webkit-box-shadow": "0 0 0px 1000px #E7F0FE inset",
    transition: "background-color 5000s ease-in-out 0s",
  },
  "& input:-webkit-autofill:hover": {
    "-webkit-text-fill-color": "#000",
    "-webkit-box-shadow": "0 0 0px 1000px #E7F0FE inset",
    transition: "background-color 5000s ease-in-out 0s",
  },
  "& input:-webkit-autofill:focus": {
    "-webkit-text-fill-color": "#000",
    "-webkit-box-shadow": "0 0 0px 1000px #E7F0FE inset",
    transition: "background-color 5000s ease-in-out 0s",
  },
};

export const scrollbarStyles = {
  "&::-webkit-scrollbar": {
    width: "5px",
    height: "5px",
  },
  "&::-webkit-scrollbar-track": {
    borderRadius: "10px",
    marginTop: "60%",
    marginBottom: "60%",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#34C759",
    borderRadius: "10px",
    height: "5vh",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "#555",
  },
  "&::-webkit-scrollbar-track-piece": {
    marginBottom: "0px",
    height: "100px",
  },
};

export const buttonStyles = (mode) => ({
  root: {
    boxShadow: "none !important",
    color: `${white} !important`,
    border: `1px solid ${green} !important`,
    transition: "all 0.4s ease !important",
    backgroundColor: `${green} !important`,
    display: "flex !important",
    justifyContent: "center !important",
    "&:hover": {
      backgroundColor: `${mode === "light" ? white : darkBg} !important`,
      border: `1px solid ${mode === "light" ? "#4CAF50" : "#4CAF50"} !important`,
      color: `${mode === "light" ? "#4CAF50" : white} !important`,
    },
    "&:active": {
      boxShadow: "none !important",
    },
    "&:focus": {
      boxShadow: "none !important",
    },
    "&:disabled": {
      backgroundColor: "#ccc !important",
      color: "#777 !important",
      border: "1px solid #ccc !important",
      cursor: "not-allowed !important",
    },
    fontSize: "1rem !important",
    textTransform: "none !important",
    "&::first-letter": {
      textTransform: "uppercase !important",
    },
  },
  label: {
    textTransform: "none !important",
    "&::first-letter": {
      textTransform: "lowercase !important",
    },
  },
});
